// Protected endpoints — use the authenticated instance so the
// Authorization: Bearer <token> header is attached (verifyJWT requires it).
import { axiosPrivate } from "../../../api/axios";

const BASE = "/api/ai-studio/qa-engineer";

export const qaApi = {
  listRepositories: () => axiosPrivate.get(`${BASE}/repositories`).then((r) => r.data),
  createRepository: (payload) =>
    axiosPrivate.post(`${BASE}/repositories`, payload).then((r) => r.data),
  deleteRepository: (id) => axiosPrivate.delete(`${BASE}/repositories/${id}`).then((r) => r.data),
  indexRepository: (id) =>
    axiosPrivate.post(`${BASE}/repositories/${id}/index`).then((r) => r.data),
  updateTestConfig: (id, testConfig) =>
    axiosPrivate.patch(`${BASE}/repositories/${id}/test-config`, testConfig).then((r) => r.data),

  listCommits: (params = {}) =>
    axiosPrivate.get(`${BASE}/commits`, { params }).then((r) => r.data),
  getCommit: (id) => axiosPrivate.get(`${BASE}/commits/${id}`).then((r) => r.data),
  reanalyzeCommit: (id) =>
    axiosPrivate.post(`${BASE}/commits/${id}/reanalyze`).then((r) => r.data),

  listReports: (params = {}) =>
    axiosPrivate.get(`${BASE}/reports`, { params }).then((r) => r.data),
  getReport: (id) => axiosPrivate.get(`${BASE}/reports/${id}`).then((r) => r.data),

  getSubgraph: (filePath, repoId) =>
    axiosPrivate.get(`${BASE}/graph/subgraph`, { params: { filePath, repoId } }).then((r) => r.data),
};

/* Shared UI helpers */
export const RISK_META = {
  LOW: { label: "Low", className: "bg-green-500/15 text-green-600 dark:text-green-300", dot: "bg-green-500" },
  MEDIUM: { label: "Medium", className: "bg-yellow-500/15 text-yellow-600 dark:text-yellow-300", dot: "bg-yellow-500" },
  HIGH: { label: "High", className: "bg-orange-500/15 text-orange-600 dark:text-orange-300", dot: "bg-orange-500" },
  CRITICAL: { label: "Critical", className: "bg-red-500/15 text-red-600 dark:text-red-300", dot: "bg-red-500" },
};

export const RECOMMENDATION_META = {
  APPROVE: { label: "Approve", className: "bg-green-500/15 text-green-600 dark:text-green-300" },
  REQUEST_CHANGES: { label: "Request Changes", className: "bg-orange-500/15 text-orange-600 dark:text-orange-300" },
  BLOCK: { label: "Block", className: "bg-red-500/15 text-red-600 dark:text-red-300" },
};

export const formatTime = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return String(value);
  }
};
